module.exports = __webpack_public_path__ + "static/media/p208g5.428d193d.jpg";